var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.player)?_c('Player',{staticClass:"player",class:['table-seat-' + (_vm.tableSeatNumber), { playing: _vm.player_playing === _vm.tableSeatNumber }],attrs:{"doodle":_vm.doodle,"player":_vm.player}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }